export const styles = {
  labelWrapper: {
    display: 'flex',
  },
  labelText: {
    color: '#707087',
    marginBottom: '5px',
    fontWeight: '200',
    fontSize: '14px',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  mandatory: {
    color: 'crimson',
    marginLeft: '5px',
  },
}
